import React from "react";
import { Icon } from "@iconify/react";
import { Muted, Small, Toolbar } from "./AppDataStyles";

/**
 * Page controls driven by the backend's `pagination` block (has_previous / has_next).
 */
export const Pager = ({ pagination, onPage, loading = false, label = "rows" }) => {
  if (!pagination) return null;

  // Nothing to page through: no controls needed.
  if (!pagination.hasPrevious && !pagination.hasNext && pagination.totalPages <= 1) {
    return null;
  }

  return (
    <Toolbar>
      <Small
        type="button"
        disabled={!pagination.hasPrevious || loading}
        onClick={() => onPage(pagination.page - 1)}
      >
        <Icon icon="lucide:chevron-left" /> Previous
      </Small>

      <Muted>
        Page {pagination.page} of {pagination.totalPages} · {pagination.total} {label}
      </Muted>

      <Small
        type="button"
        disabled={!pagination.hasNext || loading}
        onClick={() => onPage(pagination.page + 1)}
      >
        Next <Icon icon="lucide:chevron-right" />
      </Small>
    </Toolbar>
  );
};

export default Pager;
